<template>
  <div
    class="thank-you-wrapper row"
    :style="{
      '--borderColor': borderColor,
      '--textColor': textColor,
      '--referenceColor': referenceColor,
      '--mobileVisualBottomOffset': haveActivator ? '30%' : '20%'
    }"
  >
    <div class="content col-md-7 col-12">
      <div class="header">
        <h1>Iti multumim</h1>
        <h4>Pentru participarea la „{{ campaignName }}”</h4>
      </div>
      <div class="info-section mb-5">
        <span
          >Datele tale au fost primite, iar dupa ce acestea vor fi verificate,
          premiul tau va fi trimis in cel mai scurt timp! Iti multumim pentru
          participare!</span
        >
      </div>
      <div class="home-button d-none d-sm-none d-md-block d-lg-block d-xl-block mt-5">
        <buttonComponent
          name="home"
          class="btn-link"
          @click.native="goToPage"
          text="Catre prima pagina"
        />
    </div>
    </div>
    <div class="visual col-md-5 col-12">
      <div class="activator">
        <img
          v-if="haveActivator"
          src="/assets/campaigns/ProtexCarrefour/activator.png"
        />
      </div>
      <div class="protex">
        <img
        :style="imageStyles"
        :class="classNames"
        :src="`/assets/campaigns/${campaign}/visual.png`" />
      </div>
    </div>
    <div class="home-button d-block d-sm-block d-md-none d-lg-none d-xl-none mb-5">
      <buttonComponent
        name="home"
        class="btn-link"
        @click.native="goToPage"
        text="Catre prima pagina"
       />
    </div>
  </div>
</template>

<script>
import buttonComponent from "@/components/renderers/button-component.vue";

export default {
  name: "thank-you-winner",
  components: { buttonComponent },
  props: {
    imageSource: {
      required: false,
      type: String
    },
    classNames:{
      required: false,
      type: String
    },
    imageStyles: {
      type: Object,
      default: ()=>{}
    },
    campaign: {
      required: false,
      type: String,
      default: ""
    },
    campaignName: {
      required: false,
      type: String,
      default: ""
    },
    haveActivator: {
      required: false,
      type: Boolean,
      default: () => true
    },
    textColor: {
      required: false,
      type: String,
      default: "#0f2967"
    },
    referenceColor: {
      required: false,
      type: String,
      default: "#057dc3"
    },
    borderColor: {
      required: false,
      type: String,
      default: "#7997e1"
    }
  },
  methods: {
    goToPage() {
      window.location.href = "/";
    }
  },
  computed: {
    referenceNumber() {
      return this.$store.state.formData["referenceNumber"];
    }
  }
};
</script>

<style scoped lang="scss">
.thank-you-wrapper {
  // position: relative;
  // padding-top: 70px;

  .content {
    position: relative;
    padding-top: 100px;
    position: relative;
    padding-bottom: 50px;

    @media (max-width: 767px) {
      padding: 80px 25px 50px;
    }

    .header {
      h4 {
        color: var(--textColor);
        font-weight: 500;
        padding: 10px 0 50px;

        @media (max-width: 767px) {
          padding: 10px 0 30px;
        }
      }
      // div {
      //   padding: 10px 0 50px;
      //   span {
      //     color: #12327d;
      //     font-size: 20px;
      //   }

      //   @media (max-width: 767px) {
      //     padding: 10px 0 30px;

      //     span {
      //       font-size: 14px;
      //     }
      //   }
      // }
    }

    .reference-wrapper {
      background: #ffffff;
      border: 1px solid var(--borderColor);
      box-sizing: border-box;
      border-radius: 16px;
      padding: 30px;

      @media (max-width: 767px) {
        padding: 20px;
        span {
          font-size: 14px !important;
        }
      }

      span {
        color: var(--textColor);
        font-size: 16px;
        font-weight: normal;
        line-height: 26px;

        strong {
          color: var(--referenceColor);
        }
      }
    }

    .info-section {
      padding: 30px 0 60px;
      span {
        font-size: 12px;
        color: var(--textColor);
        line-height: 19px;
      }
    }

    .home-button {
      position: absolute;
      bottom: 10%;

      button {
        padding: 0;
      }

      @media (max-width: 767px) {
        bottom: 0;
      }
    }
  }

  .visual {
    @media (max-width: 767px) {
      padding-left: 0;
      padding-right: 0;
    }
    .activator {
      min-height: 600px;
      @media (max-width: 767px) {
        min-height: 400px;
        img {
          width: 100%;
        }
      }
    }
    .protex {
      position: absolute;
      top: 25%;
      @media (max-width: 992px)
      {
        top:40% !important;
      }
      img {
        width: 100%;        
      }
      @media (max-width: 767px) {
        top: 5% !important;
        left: 7%;
        right: 7%;
        bottom: var(--mobileVisualBottomOffset);
      }
    }
  }
  .smoothies-helper {
    margin-left: 50%;    
    @media (max-width: 767px) {
      width: 250px !important;
      margin-left: 19% !important;
    }
    @media (max-width: 1000px) {
      margin-left: 20%;
    }
  }
}
</style>
